<template>
  <div>
    <forms-container
      v-if="isMounted"
      :investor_id="InvestorId"
      :investor_status="InvestorStatus"
      :user_id="UserId"
      :moral-tabs="moralTabs"
      :pfae-tabs="pfaeTabs"
      :full-disabled="true"
    />
  </div>
</template>

<script>
import FormsContainer from "@components/profile_shared/FormsContainer";
import investorInfoHelper from "@/helpers/investorInfoHelper";
export default {
  name: "InvestorContact",
  components: {
    FormsContainer
  },
  mixins: [investorInfoHelper],
  data(){
    return {
      pfaeTabs: ['address'],
      moralTabs: ['address'],
      isMounted: false,
      InvestorId: null,
      InvestorStatus: null,
      UserId: null,
      UserPersonType: null,
    }
  },
  beforeMount() {
    this.InvestorId = this.$route.params.id;
  },
  async mounted(){
    this.isMounted = false
    this.showLoading(true)
    await this.getInvestorInfo();
    this.isMounted = true
    this.showLoading(false)
  },
  methods:{
    async getInvestorInfo(){
      const requiredObjects = ['user'];
      const investor = await this.getInvestorData(this.InvestorId, requiredObjects);
      this.InvestorStatus = investor.status;
      this.UserId = investor.user.id;
      this.UserPersonType = investor.user.person_type;
    },
  }
}
</script>
